import defineMessages from "../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    tempo: {
        id: "tasks.tempo",
    },
});

export default messages;
